"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accounts = void 0;
const proto_signing_1 = require("@cosmjs/proto-signing");
const crypto_1 = __importDefault(require("crypto"));
class Accounts {
    constructor() {
        this.prefix = "6x";
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param mnemoniclength The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */
    create(mnemonicLength = 24) {
        return __awaiter(this, void 0, void 0, function* () {
            return proto_signing_1.DirectSecp256k1HdWallet.generate(mnemonicLength, { prefix: this.prefix });
        });
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     */
    mnemonicKeyToAccount(mnemonic) {
        return __awaiter(this, void 0, void 0, function* () {
            return proto_signing_1.DirectSecp256k1HdWallet.fromMnemonic(mnemonic, { prefix: this.prefix });
        });
    }
    /**
     * Restores a wallet from the given privatekey.
     *
     * @param privatekey Any valid privatekey.
     */
    privateKeyToAccount(privateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (privateKey.startsWith("0x")) {
                privateKey = privateKey.slice(2);
            }
            const cryptoConverter = crypto_1.default.createECDH('secp256k1');
            cryptoConverter.setPrivateKey(privateKey, 'hex');
            // console.log(xxx)
            return proto_signing_1.DirectSecp256k1Wallet.fromKey(cryptoConverter.getPrivateKey(), this.prefix);
        });
    }
}
exports.Accounts = Accounts;
//# sourceMappingURL=Accounts.js.map